import type { FaireProductEntity } from "../../entity_types/product";

export const p_7wss2n6nbx: FaireProductEntity = {
  token: "p_7wss2n6nbx",
  type: "product",
  name: "Newborn bundle | olive green",
  brandToken: "b_2odghsszwq",
  brandName: "Goodnightdoll",
  imageUrl:
    "https://cdn.faire.com/fastly/4b4bf66b3418f97d01092d0a87ba07c515102929e44f41ce9c5e3bb74546f52c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/98c29701fa09c0cd455d2db8c8dd978e403661704ff9bde08a538acf8332876e.jpeg",
    "https://cdn.faire.com/fastly/ce1b8e883c04fbd98f2e6712b7bc55f701f0787a576ffdfac0c7302c7622cb3d.jpeg",
    "https://cdn.faire.com/fastly/9d157be797b8ec144cdbe1135e7001665d0558da308996e13722e27519f465b1.jpeg",
    "https://cdn.faire.com/fastly/9e33dc1169f3fdd713b38ee1a7ff095301e67f993e9e0374882912e9aac92e00.jpeg",
  ],
  priceDollars: 25,
  description:
    "\nWith our newborn bundles get the ultimate set. This includes the knotted gown, swaddle and cap. This knotted gown has built in fold over gloves to avoid newborn scratches. The perfect addition to bring to the hospital. These sets also make great baby gifts as well! \n",
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:39.595Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
